import { AppDispatch } from "store";
import { ActionTypes } from "utils/constants"

export const startLoader:any = () => (dispatch: AppDispatch) => {
    dispatch({ type: ActionTypes.START_LOADING });
}

export const endLoader:any = () => (dispatch: AppDispatch) => {
    dispatch({ type: ActionTypes.END_LOADING })
}